<template>
  <CoreExpand
    :title="manualsHeading"
  >
    <div
      v-for="(manual, i) in manuals"
      :key="i"
      class="text-4 md:text-3 mb-4 leading-tight"
    >
      <span class="flex items-center">
        <a
          :href="filterFields(manual).file.url"
          target="_blank"
          class="link link-alt"
          v-text="filterFields(manual).title"
        />
      </span>
    </div>
  </CoreExpand>
</template>

<script>
import { filterFields } from '@io';

export default {
  name: 'TenantAreaManuals',

  props: {
    manualsHeading: {
      type: String,
      default: '',
    },
    manuals: {
      type: Array,
      default: () => ([]),
    },
  },

  methods: {
    filterFields,
  },
};
</script>
